import React from "react";
import "./ExploreAllcard.css";

const ExploreAllCard = ({ ExploreAll, allItems, onImageClick }) => {
  return (
    <div className="ExploreAll-card">
      <img
        src={ExploreAll.image}
        alt={ExploreAll.name}
        className="ExploreAll-card__image"
        onClick={() => onImageClick(ExploreAll.id, allItems)}
      />
      <div className="ExploreAll-card__overlay"></div>
      <div className="ExploreAll-card__name">{ExploreAll.name}</div>
    </div>
  );
};

export default ExploreAllCard;
